import { styled } from '@mui/material/styles';

export const Content = styled('div')`
  display: flex;
  padding: 10px 20px;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  font-family: 'Segoe UI', sans-serif;

  /* Glassmorphism responsivo ao tema */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  box-shadow: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? '0 8px 32px rgba(0, 0, 0, 0.5)'
      : '0 8px 24px rgba(0, 0, 0, 0.08)'};

  background: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? 'linear-gradient(145deg, rgba(42, 52, 77, 0.85) 0%, rgba(0, 207, 255, 0.12) 100%)'
      : 'linear-gradient(145deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 246, 251, 0.9) 100%)'};

  .divider {
    width: 1px;
    height: 20px;
    background-color: ${({ theme }) => theme.palette.grey['05']};
  }
`;

interface TabProps {
  active: boolean;
}

export const TabButton = styled('div')<TabProps>`
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${(props) =>
    props.active ? props.theme.palette.primary['01'] : 'transparent'};
  color: ${(props) => (props.active ? '#ffffff' : '#ccc')};

  :hover,
  :active {
    color: ${({ theme }) => theme.palette.primary['01']};
    background-color: ${({ theme }) => `${theme.palette.primary['01']}20`};
  }

  a i {
    font-size: 16px;
  }

  .tab-label {
    display: inline-block;
    max-width: 0;
    margin-left: 0;
    opacity: 0;
    overflow: hidden;
    white-space: nowrap;
    transition:
      max-width 0.3s ease,
      margin-left 0.3s ease,
      opacity 0.2s ease;
  }

  &:hover .tab-label,
  &.label-visible .tab-label {
    max-width: 160px;
    margin-left: 8px;
    opacity: 1;
  }
`;
